import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const ContatoContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: var(--color-dark);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Title = styled(motion.h1)`
  color: var(--color-white);
  font-size: 3rem;
  margin-bottom: 3rem;
  text-align: center;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -15px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 3px;
    background-color: var(--color-primary);
    border-radius: 3px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  gap: 2rem;
  margin-bottom: 3rem;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FormContainer = styled(motion.div)`
  flex: 1;
  background: rgba(26, 26, 26, 0.7);
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 144, 82, 0.2);
  backdrop-filter: blur(10px);
`;

const InfoContainer = styled(motion.div)`
  flex: 1;
  background: rgba(26, 26, 26, 0.7);
  border-radius: 15px;
  padding: 2rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 144, 82, 0.2);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
`;

const FormTitle = styled.h2`
  color: var(--color-white);
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
`;

const FormGroup = styled.div`
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  display: block;
  color: var(--color-white);
  margin-bottom: 0.5rem;
  font-size: 1rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.8rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 144, 82, 0.2);
  border-radius: 8px;
  color: var(--color-white);
  font-size: 1rem;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 10px rgba(255, 144, 82, 0.3);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 0.8rem 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 144, 82, 0.2);
  border-radius: 8px;
  color: var(--color-white);
  font-size: 1rem;
  min-height: 150px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: var(--color-primary);
    box-shadow: 0 0 10px rgba(255, 144, 82, 0.3);
  }
`;

const SubmitButton = styled(motion.button)`
  background: rgba(255, 144, 82, 0.2);
  color: var(--color-white);
  font-size: 1rem;
  padding: 0.8rem 1.5rem;
  border-radius: 50px;
  border: 2px solid var(--color-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 0 15px rgba(255, 144, 82, 0.2);
  backdrop-filter: blur(5px);

  &:hover {
    background: rgba(255, 144, 82, 0.3);
  }
`;

const InfoTitle = styled.h2`
  color: var(--color-white);
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

const InfoIcon = styled.div`
  font-size: 1.5rem;
  color: var(--color-primary);
  filter: drop-shadow(0 0 5px rgba(255, 144, 82, 0.3));
`;

const InfoText = styled.div`
  color: var(--color-white);
  opacity: 0.8;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: auto;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 144, 82, 0.2);
`;

const SocialLink = styled(motion.a)`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 144, 82, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-white);
  font-size: 1.5rem;
  text-decoration: none;
  border: 1px solid rgba(255, 144, 82, 0.3);

  &:hover {
    background: rgba(255, 144, 82, 0.3);
  }
`;

const SuccessMessage = styled(motion.div)`
  background: rgba(39, 174, 96, 0.2);
  border: 1px solid rgba(39, 174, 96, 0.5);
  padding: 1rem;
  border-radius: 8px;
  color: var(--color-white);
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const ErrorMessage = styled(motion.div)`
  background: rgba(231, 76, 60, 0.2);
  border: 1px solid rgba(231, 76, 60, 0.5);
  padding: 1rem;
  border-radius: 8px;
  color: var(--color-white);
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const BackButton = styled(motion.button)`
  background: rgba(26, 26, 26, 0.7);
  color: var(--color-white);
  font-size: 1rem;
  padding: 0.8rem 1.5rem;
  border-radius: 50px;
  border: 2px solid var(--color-primary);
  margin-top: 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 15px rgba(255, 144, 82, 0.2);
  backdrop-filter: blur(5px);

  &:hover {
    background: rgba(255, 144, 82, 0.2);
  }
`;

const Contato: React.FC<{ onBack: () => void }> = ({ onBack }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [formStatus, setFormStatus] = useState<"idle" | "success" | "error">(
    "idle"
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    e.preventDefault();

    const { name, email, subject, message } = formData;

    const whatsappNumber = "5511989857740";

    const formattedMessage = `Hi, my name is ${name}.
          E-mail: ${email}
          Subject: ${subject || "No subject"}
          Message: ${message}`;

    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      formattedMessage
    )}`;

    window.open(whatsappUrl, "_blank");

    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  return (
    <ContatoContainer>
      <Title
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Contact Me
      </Title>

      <ContentWrapper>
        <FormContainer
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <FormTitle>Send a message</FormTitle>

          {formStatus === "success" && (
            <SuccessMessage
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              <span role="img" aria-label="success">
                ✅
              </span>
              Message sent successfully! I will get in touch soon.
            </SuccessMessage>
          )}

          {formStatus === "error" && (
            <ErrorMessage
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              <span role="img" aria-label="error">
                ❌
              </span>
              Please fill in all required fields.
            </ErrorMessage>
          )}

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label htmlFor="name">Name *</Label>
              <Input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="email">Email *</Label>
              <Input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="subject">Subject</Label>
              <Input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </FormGroup>

            <FormGroup>
              <Label htmlFor="message">Message *</Label>
              <TextArea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
              />
            </FormGroup>

            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <span role="img" aria-label="loading">
                    ⏳
                  </span>
                  Sending...
                </>
              ) : (
                <>
                  <span role="img" aria-label="send">
                    📨
                  </span>
                  Send Message
                </>
              )}
            </SubmitButton>
          </form>
        </FormContainer>

        <InfoContainer
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <InfoTitle>Contact</InfoTitle>

          <InfoItem>
            <InfoIcon>📧</InfoIcon>
            <InfoText>caique1994_1@hotmail.com</InfoText>
          </InfoItem>

          <InfoItem>
            <InfoIcon>📱</InfoIcon>
            <InfoText>+55 (11) 98985-7740</InfoText>
          </InfoItem>

          <InfoItem>
            <InfoIcon>📍</InfoIcon>
            <InfoText>São Paulo, Brasil</InfoText>
          </InfoItem>

          <InfoItem>
            <InfoIcon>💼</InfoIcon>
            <InfoText>Available for game projects</InfoText>
          </InfoItem>

          <SocialLinks>
            <SocialLink
              href="https://linkedin.com/in/carbonegoncalves"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, rotate: 5 }}
              whileTap={{ scale: 0.9 }}
            >
              <span role="img" aria-label="LinkedIn">
                👔
              </span>
            </SocialLink>

            <SocialLink
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, rotate: 5 }}
              whileTap={{ scale: 0.9 }}
            >
              <span role="img" aria-label="itchi.io">
                💻
              </span>
            </SocialLink>

            <SocialLink
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, rotate: 5 }}
              whileTap={{ scale: 0.9 }}
            >
              <span role="img" aria-label="Twitter">
                🐦
              </span>
            </SocialLink>

            <SocialLink
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.1, rotate: 5 }}
              whileTap={{ scale: 0.9 }}
            >
              <span role="img" aria-label="Instagram">
                📸
              </span>
            </SocialLink>
          </SocialLinks>
        </InfoContainer>
      </ContentWrapper>

      <BackButton
        onClick={onBack}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Back to Menu
      </BackButton>
    </ContatoContainer>
  );
};

export default Contato;
